/**
 * CareerSection — ★ Fase 33: wrapper Dashboard Carriera ES.
 *
 * Rendering:
 *  • Admin/amministrativo con tenant CRM attivo = 'es' → CareerTeamPanel.
 *  • Utente ES bloccato (crm_tenant_locked='es'):
 *      – direttore (Sofia)   → CareerTeamPanel
 *      – agente Setter/Junior/Senior → CareerDashboard personale
 *  • Altri tenant → null (nessun impatto su CRM IT/EN).
 */
import React, { useCallback, useEffect, useState } from 'react';
import { api } from '../../lib/api';
import { useAuth } from '../../lib/auth-context';
import { useCrmTenant } from '../CrmTenantSwitcher';
import { CareerDashboard } from './CareerDashboard';
import { CareerTeamPanel } from './CareerTeamPanel';

export function CareerSection() {
  const { user } = useAuth();
  const { tenant } = useCrmTenant();
  const isAdminLike = ['admin', 'amministrativo'].includes((user?.role || '').toLowerCase());
  const lockedEs = (user?.crm_tenant_locked || '').toLowerCase() === 'es';
  const adminOnEs = isAdminLike && tenant === 'es';

  const now = new Date();
  const [year, setYear] = useState(now.getUTCFullYear());
  const [month, setMonth] = useState(now.getUTCMonth() + 1);
  const [me, setMe] = useState(null);
  const [loading, setLoading] = useState(false);

  const active = lockedEs || adminOnEs;

  const load = useCallback(() => {
    if (!active) return;
    setLoading(true);
    api.get('/career/me', { params: { year, month } })
      .then((r) => setMe(r.data))
      .catch(() => setMe(null))
      .finally(() => setLoading(false));
  }, [active, year, month]);

  useEffect(() => { load(); }, [load]);

  if (!active) return null;

  // Admin su tenant ES o direttore ES → pannello team
  if (adminOnEs || me?.is_director) {
    return <CareerTeamPanel />;
  }

  if (!me?.eligible && !loading) return null;

  const changeMonth = (delta) => {
    let m = month + delta;
    let y = year;
    if (m < 1) { m = 12; y -= 1; }
    if (m > 12) { m = 1; y += 1; }
    setMonth(m); setYear(y);
  };

  return <CareerDashboard data={me?.eligible ? me : null} loading={loading} onChangeMonth={changeMonth} />;
}
